module.exports = __webpack_public_path__ + "5ade0b1a90f7b0e849aff02d016e18f1.MP3";